import React from 'react';
import { ShoppingCart, Lock, RefreshCw, Headphones, Tag } from 'lucide-react';
import type { TFunction } from 'i18next';

export interface OrderSummaryProps {
  planName: string;
  payrollName: string | null;
  planMonthly: number;
  payrollMonthly: number;
  subtotal: number;
  founderDiscount: number;
  total: number;
  t: TFunction;
}

export function OrderSummary({ planName, payrollName, planMonthly, payrollMonthly, subtotal, founderDiscount, total, t }: OrderSummaryProps): React.ReactElement {
  const fmt = (n: number): string => n.toFixed(2);
  return (
    <div className="sticky rounded-md border border-brand-borderLight" style={{ background: "linear-gradient(180deg, #F0FDF4 0%, #E6F0EA 100%)", padding: "20px 18px", boxShadow: "0 6px 20px rgba(4,106,56,0.1)", top: 16 }}>
      <div className="mb-3.5 flex items-center gap-2">
        <ShoppingCart size={16} className="text-ink" />
        <div className="text-body font-medium text-ink">{t("billing.orderSummary")}</div>
      </div>
      <div className="mb-2 flex justify-between text-small text-sub">
        <span>{planName}</span><span className="font-medium">$${fmt(planMonthly)}</span>
      </div>
      {payrollName && (
        <div className="mb-2.5 flex justify-between text-small text-sub">
          <span>{payrollName}</span><span className="font-medium">$${fmt(payrollMonthly)}</span>
        </div>
      )}
      {founderDiscount > 0 && (
        <div className="mb-3 flex items-center justify-between text-tiny font-medium text-brand">
          <span className="inline-flex items-center gap-1"><Tag size={12} /> {t("billing.founderDiscount")}</span>
          <span>&minus;$${fmt(founderDiscount)}</span>
        </div>
      )}
      <div className="mb-3.5 flex items-baseline justify-between border-t border-brand-borderLight pt-3">
        <span className="text-body font-medium text-ink">{t("billing.totalToday")}</span>
        <div>
          <span className="text-hero font-semibold text-ink">$${fmt(total)}</span>
          <span className="ml-1 text-tiny text-muted">CAD</span>
        </div>
      </div>
      <div className="border-t border-brand-borderLight pt-3 text-tiny text-sub" style={{ lineHeight: 1.8 }}>
        <div className="mb-1 flex items-center gap-2"><Lock size={13} className="text-brand" /><span>{t("billing.trustEncryption")}</span></div>
        <div className="mb-1 flex items-center gap-2"><RefreshCw size={13} className="text-brand" /><span>{t("billing.trustCancel")}</span></div>
        <div className="flex items-center gap-2"><Headphones size={13} className="text-brand" /><span>{t("billing.trustSupport")}</span></div>
      </div>
      <div className="mt-2.5 text-tiny text-muted leading-relaxed">{t("billing.taxNote")}</div>
    </div>
  );
}
